import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterType } from 'src/app/features/secured-skeleton/models/global-search';
import { environment } from 'src/environments/environment';
import { Observable, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  // Dictionary to store cached results
  private cache: { [key: string]: any } = {};

  constructor(private http: HttpClient) {}

  getSearchResults(searchTerms: string[], filterType: FilterType): Observable<any> {
    const cacheKey = this.generateCacheKey(searchTerms, filterType);

    // Check if the result is already cached
    if (this.cache[cacheKey]) {
      return of(this.cache[cacheKey]); // Return cached result as an Observable
    }

    // If not cached, make the HTTP request
    const result$ = this.http
      .get(`${environment.restUrl}/v1/hub/global-search`, {
        params: {
          searchQuery: searchTerms.join(','),
          filterType: filterType,
        },
      })
      .pipe(
        shareReplay(1), // Share the result and replay it for future subscribers
      );

    // Store the result in the cache
    result$.subscribe((result) => {
      this.cache[cacheKey] = result;
    });

    return result$;
  }

  // Helper function to generate a unique cache key
  private generateCacheKey(searchTerms: string[], filterType: FilterType): string {
    // Sort the searchTerms array to ensure consistency in cache keys
    searchTerms.sort();
    return JSON.stringify({ searchTerms, filterType });
  }
}
